import Input from '../../common/Input';
import Select from '../../common/Select';
import CheckBox from '../../common/CheckBox';
import Toggle from '../../common/Toggle';

export const newCustomFields = {

  id: 0,

  _system: {
    name: 'New Custom Fields',
    relatedTo: 'newCustomFields',
  },

  label: {
    label: 'Label:',
    placeholder: '',
    system: {
      component: Input,
      name: 'label',
      relatedTo: 'newCustomFields',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'label',
    rules: {
      title: 'Label field',
      required: true,
    }
  },
  type: {
    label: 'Type:',
    placeholder: '',
    system: {
      component: Select,
      name: 'type',
      relatedTo: 'newCustomFields',
    },
    value: 'Free text field',
    source: [
      {"value": "Free text field", "text": "Free text field"},
      {"value": "External link", "text": "External link"},
      {"value": "Number", "text": "Number"},
      {"value": "Dropdown with options", "text": "Dropdown with options"},
      {"value": "Date picker", "text": "Date picker"}
    ],
    errors: [],
    type: 'text',
    name: 'type',
    rules: {
      title: 'Type fields',
      required: true,
    }
  },
  width: {
    label: 'Width:',
    placeholder: '',
    system: {
      component: Select,
      name: 'width',
      relatedTo: 'newCustomFields',
    },
    value: '25%',
    source: [{"value": "25%", "text": "25%"}, {"value": "50%", "text": "50%"}, {
      "value": "75%",
      "text": "75%"
    }, {"value": "100%", "text": "100%"}],
    errors: [],
    type: 'text',
    name: 'width',
    rules: {
      title: 'Width fields',
      required: true,
    }
  },
  option: {
    label: 'Option:',
    placeholder: 'Allowed values separate by semicolon',
    system: {
      component: Input,
      name: 'option',
      relatedTo: 'newCustomFields',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'option',
    rules: {
      title: 'Option field',
    }
  },
  showOnDashboard: {
    label: 'Show on a job card',
    system: {
      component: Toggle,
      name: 'showOnDashboard',
      relatedTo: 'newCustomFields',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'showOnDashboard',
    rules: {
      required: false,
    }
  },
  isRequired: {
    label: 'Required',
    system: {
      component: CheckBox,
      name: 'isRequired',
      relatedTo: 'newCustomFields',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'isRequired',
    rules: {
      required: false,
    }
  },
};

export const allFields = {
  id: {
    system: {
      name: 'id',
    },
    value: '',
  },
  label: {
    system: {
      name: 'label',
    },
    value: '',
  },
  value: {
    system: {
      name: 'enabled',
    },
    value: '',
  },
  order: {
    system: {
      name: 'order',
    },
    value: '',
  },
  showOnDashboard: {
    system: {
      name: 'showOnDashboard',
    },
    value: false,
  },
  isRequired: {
    system: {
      name: 'isRequired',
    },
    value: false,
  },
  options: {
    system: {
      name: 'options',
    },
    value: '',
  },
  show: {
    system: {
      name: 'show'
    },
    value: false,
  },
  type: {
    system: {
      name: 'type'
    },
    value: '',
  }
};

export const options = {
  label: {
    label: 'Label:',
    placeholder: '',
    system: {
      component: Input,
      name: 'label',
      relatedTo: 'options',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'label',
    rules: {
      title: 'Label field',
      required: true,
    }
  },
  type: {
    label: 'Type:',
    placeholder: '',
    system: {
      component: Select,
      name: 'type',
      relatedTo: 'options',
    },
    value: '',
    source: [
      {"value": "Free text field", "text": "Free text field"},
      {"value": "External link", "text": "External link"},
      {"value": "Number", "text": "Number"},
      {"value": "Dropdown with options", "text": "Dropdown with options"},
      {"value": "Date picker", "text": "Date picker"}
    ],
    errors: [],
    type: 'text',
    name: 'type',
    rules: {
      title: 'Type fields',
      required: true,
    }
  },
  width: {
    label: 'Width:',
    placeholder: '',
    system: {
      component: Select,
      name: 'width',
      relatedTo: 'options',
    },
    value: '',
    source: [{"value": "25%", "text": "25%"}, {"value": "50%", "text": "50%"}, {
      "value": "75%",
      "text": "75%"
    }, {"value": "100%", "text": "100%"}],
    errors: [],
    type: 'text',
    name: 'width',
    rules: {
      title: 'Width fields',
      required: true,
    }
  },
  option: {
    label: 'Option:',
    placeholder: 'Allowed values separate by semicolon',
    system: {
      component: Input,
      name: 'option',
      relatedTo: 'options',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'option',
    rules: {
      title: 'Option field',
      required: true,
    }
  },
  isRequired: {
    label: 'Required',
    system: {
      component: CheckBox,
      name: 'isRequired',
      relatedTo: 'newCustomFields',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'isRequired',
    rules: {
      required: false,
    }
  },
};

export const basic = {
  newCustomFields: [],
  allAvailableFields: [],
  options,
};



// WEBPACK FOOTER //
// ./src/containers/JobCardsTemplate/fields.js